<template>
	<section>
		<x-panel margin class="mb-3">
			<div slot="title">
				<h3>Tasks</h3>
			</div>
			<div slot="extra" :class="`d-flex justify-content-end`">
				<el-button @click="setView('table')" class="filter-item ml-2" :type="view == 'table' ? 'success' : 'info'">
					Table View
				</el-button>
				<el-button @click="setView('calendar')" class="filter-item ml-2" :type="view == 'calendar' ? 'success' : 'info'">
					Calendar View
				</el-button>
			</div>
		</x-panel>
        <tasks-table :token="token" :application-id="applicationId" :show-all-tasks="showAllTasks" v-if="view == 'table'" :broker-list="brokerList" :team-id="teamId"></tasks-table>
        <tasks-calendar :token="token" :application-id="applicationId" :show-all-tasks="showAllTasks" v-if="view == 'calendar'" :broker-list="brokerList" :team-id="teamId"></tasks-calendar>
	</section>
</template>

<script>
    import { mapState } from 'vuex'
    import TasksTable from "@ambition/components/tasks/TasksTable.vue";
    import TasksCalendar from "@ambition/components/tasks/TasksCalendar.vue";
	export default {
		name: "Tasks",
        components: {
            TasksTable,
            TasksCalendar,
        },
        props: {
            token: {
                required: true
            },
            applicationId: {
                required: false,
                type: [String, Number]
            },
            showAllTasks: {
                required: false,
                type: Boolean,
                default: false,
            }
        },
		data() {
            return {
                teamId: _.get(Ambition, "Globals.tenant.user.current_team_id", null),
                brokerUsers: [],
                brokerList: [],
			}
		},
        computed: {
            view: {
                set(view) {
                    this.$store.dispatch('tasks/setView', view)
                },
                get() {
                    return this.$store.getters['tasks/getView']
                }
            }
        },
        mounted() {
            this.getBrokersList()
            if (localStorage['task-view']) this.view = localStorage['task-view']
        },
		created() {
            this.$store.dispatch("user/saveUser", this.token)
        },
		methods: {
			setView(view) {
                if (this.view !== view) {
                    this.view = view
                    localStorage['task-view'] = view;
                }
			},
            getBrokersList() {
				axios.post(`/api/v2/referrers/get-brokers`, {
                        teamId: this.teamId,
                    }, {
						headers: {
							Authorization: `Bearer ${this.$store.getters.token}`,
						}
					})
					.then((res) => {

                        let activeBrokerList = res.data.filter((item) => !item.deleted_at && item.active)
                        let inactiveBrokerListWithTasks = res.data.filter(item => (item.deleted_at || !item.active) && !_.isEmpty(item.assigned_tasks))

                        if (!_.isEmpty(activeBrokerList)) {
                            this.brokerList.push({
                                label: "Active Brokers",
                                options: activeBrokerList.map(broker => {
                                    return {
                                        value: broker.id,
                                        label: broker.full_name
                                    }
                                })
                            })
                        }

                        if (!_.isEmpty(inactiveBrokerListWithTasks)) {
                            this.brokerList.push({
                                label: "Inactive Brokers",
                                options: inactiveBrokerListWithTasks.map(broker => {
                                    return {
                                        value: broker.id,
                                        label: broker.full_name
                                    }
                                })
                            })
                        }

                    })
					.catch((err) => console.error(err))
			},
		},
	}
</script>

<style lang="scss" scoped>

</style>
